import { PropsWithChildren } from "react";
import { cn } from "@shortsworks/ui/lib/utils";
import { DesktopSkeletonHeader } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/Header";
import { DesktopSkeletonMenu } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/Menu";
import { DesktopSkeletonContents } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/Contents";
import { DesktopSkeletonBanner } from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/Banner";
import {
  ShortsWorksWidget,
  ShortsWorksWidgetProps,
} from "@app/components/WidgetStudio/ShortsWorksWidget";

interface DesktopSkeletonProps extends PropsWithChildren {
  widgetProps?: ShortsWorksWidgetProps;
}

export const DesktopSkeleton = ({ widgetProps }: DesktopSkeletonProps) => {
  return (
    <div className="flex flex-col gap-5">
      <DesktopSkeletonHeader />
      {/*<DesktopSkeletonMenu />*/}
      <div className="mx-5">
        {/* @ts-ignore */}
        <ShortsWorksWidget {...widgetProps} />
      </div>
      <DesktopSkeletonBanner />
      <DesktopSkeletonContents />
    </div>
  );
};
